import { getCart } from "app/redux/selectors";
import { getCartSaleId, setCartSale } from "../modules/cart";
import { getClub } from "shadow-client/redux/selectors";
import { saveSale } from "shadow-client/endpoints/saleApi";
import { saveTempContact } from "shadow-client/endpoints/contactApi";

const createCartSale = clubId => (dispatch, getState) => {
  const saleId = getCartSaleId(getCart(getState()));
  const club = getClub(getState(), clubId);

  if (saleId) {
    return Promise.resolve(saleId);
  } else {
    return dispatch(saveTempContact())
      .then(newContact => {
        return dispatch(
          saveSale(null, {
            contactId: newContact.get("@id"),
            clubId: club.get("@id"),
            clubCode: club.get("code"),
            channel: "web"
          })
        );
      })
      .then(newSale => {
        dispatch(setCartSale(newSale.get("@id")));
        return newSale.get("@id");
      });
  }
};

export default createCartSale;



// WEBPACK FOOTER //
// ./src/app/redux/actions/createCartSale.js